// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("ProximaNova-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("FontsFree-Net-Proxima-Nova-Reg-It.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Proxima Nova Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("FontsFree-Net-Proxima-Nova-Thin-It.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Proxima Nova Alt Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("FontsFree-Net-Proxima-Nova-Light-It.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Proxima Nova Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("FontsFree-Net-Proxima-Nova-Bold-It.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Proxima Nova Extrabold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("FontsFree-Net-Proxima-Nova-Xbold-It.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Proxima Nova Alt Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("FontsFree-Net-ProximaNovaAltBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("opentype");
  font-weight: 200;
  font-style: italic;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("opentype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("opentype");
  font-weight: 600;
  font-style: italic;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("opentype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("opentype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("opentype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "proxima";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("opentype");
  font-weight: 500;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/styles/proxima_nova/proxima-nova.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAsD;EACtD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAsD;EACtD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAsD;EACtD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gEAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gEAAyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"proxima\";\n  src: url(\"ProximaNova-Regular.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"FontsFree-Net-Proxima-Nova-Reg-It.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"Proxima\\ Nova\\ Thin.otf\") format(\"opentype\");\n  font-weight: 100;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"FontsFree-Net-Proxima-Nova-Thin-It.otf\") format(\"opentype\");\n  font-weight: 100;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"Proxima\\ Nova\\ Alt\\ Light.otf\") format(\"opentype\");\n  font-weight: 200;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"FontsFree-Net-Proxima-Nova-Light-It.otf\") format(\"opentype\");\n  font-weight: 200;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"Proxima\\ Nova\\ Bold.otf\") format(\"opentype\");\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"FontsFree-Net-Proxima-Nova-Bold-It.otf\") format(\"opentype\");\n  font-weight: 600;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"Proxima\\ Nova\\ Extrabold.otf\") format(\"opentype\");\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"FontsFree-Net-Proxima-Nova-Xbold-It.otf\") format(\"opentype\");\n  font-weight: 700;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"Proxima\\ Nova\\ Alt\\ Bold.otf\") format(\"opentype\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"proxima\";\n  src: url(\"FontsFree-Net-ProximaNovaAltBoldItalic.ttf\") format(\"opentype\");\n  font-weight: 500;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
